import React from 'react'
import domToReact from 'html-react-parser/lib/dom-to-react'
import isServerSide from '../../../is-server-side'
import { Helmet } from 'react-helmet-async'

const ExternalHappyContest = (attribs, embedBoxChildren) => (
  <div>
    {!isServerSide() && !document.querySelector(`script[src*="${attribs.src}"]`) && (
      <Helmet>
        <script src={attribs.src} />
      </Helmet>
    )}
    {domToReact(embedBoxChildren)}
  </div>
)

export default ExternalHappyContest
